import { Service } from './http-service';
import {
  type CalculateExampleDto,
  type CreatePricingModifiersDto,
  type ExampleCalculationDto,
  type PricingModifiers,
} from '@carvia/ros-client-types';

class PricingModifiersService extends Service<
  PricingModifiers,
  CreatePricingModifiersDto,
  undefined
> {
  async getLatest() {
    const res = await this.httpClient.get<PricingModifiers>(this.endpoint + '/latest');
    return res.data;
  }

  async calculateExample(dto: CalculateExampleDto) {
    const res = await this.httpClient.post<ExampleCalculationDto>(
      this.endpoint + '/calculate-example',
      dto,
    );
    return res.data;
  }
}

export const pricingModifiersService = new PricingModifiersService('/pricing-modifiers');
